import styled from "styled-components";

import { Media } from "../../../../theme";
import { CertificateItemMobile } from "../certificateItemMobile/certificateItemMobile.component";
import { headerItemStyles } from "../filesToDownload/filesToDownload.styled";
import { ListPagination } from "../listPagination/listPagination.component";

export const Container = styled.div``;

export const HeaderItem = styled.div`
  ${headerItemStyles}

  &:nth-of-type(1) {
    flex: 4;
  }

  &:nth-of-type(2) {
    margin-left: auto;
  }

  &:nth-of-type(4) {
    min-width: 145px;
  }
`;

export const StyledCertificateItemMobile = styled(CertificateItemMobile)`
  & + & {
    margin-top: 4px;
  }
`;

export const StyledListPagination = styled(ListPagination)`
  margin-top: 25px;

  ${Media.tabletWide`
    margin-top: 15px;
  `}
`;
